import React, { useState } from 'react';
import { AnchorId } from '../../../core/Enums';
import ManagerLayout from '../../../mimic/manager/ManagerLayout';
import { useTour } from '../../../core/TourProvider';
import { PaymentsSubsceneId } from '../../../core/PaymentsEnums';
import { useTourAnchor } from '../../../hooks/useTourAnchor';
import InvoiceTransactionContainer from '../../../components/InvoiceTransactionContainer';
import BasicHeaderFields from '../../../components/BasicHeaderFields';
import BasicHeaderTabs from '../../../components/BasicHeaderTabs';
import styles from '../../../stylesheets/managerOutstandingScene.module.scss';
import TransactionPanel from '../../../components/TransactionPanel';
type ManagerTabId = 'unit' | 'transactions' | 'messages';

const ManagerOutstandingScene = () => {
  const { next, model, currentSubscene, setSubscene } = useTour();
  const [activeTab, setActiveTab] = useState<ManagerTabId>('unit');
  const openTenantViewRef = useTourAnchor(AnchorId.OPEN_TENANT_VIEW_BUTTON);
  const outstandingInvoiceRef = useTourAnchor(
    AnchorId.MANAGER_OUTSTANDING_OUTSTANDING_INVOICE
  );
  const unitLabel = model.tenant?.unitName ?? 'Unit';

  const invoices = model.payments?.invoices ?? [];
  const outstandingInvoice =
    invoices.find((invoice) => invoice.status === 'outstanding') ?? invoices[0];
  const transactionRows = model.payments?.transactions ?? [];

  const handleOutstandingClick = () => {
    if (currentSubscene?.id === PaymentsSubsceneId.INVOICE) {
      setSubscene(PaymentsSubsceneId.PREVIEW);
    }
  };

  return (
    <ManagerLayout>
      <BasicHeaderFields
        previewButtonLabel="Preview what your tenant sees"
        previewButtonRef={openTenantViewRef}
        onPreviewClick={next}
      />
      <BasicHeaderTabs
        activeId={activeTab}
        unitLabel={unitLabel}
        onChange={setActiveTab}
      />
      <div className={styles.contentSection}>
        {activeTab === 'unit' ? (
          outstandingInvoice ? (
            <div ref={outstandingInvoiceRef} onClick={handleOutstandingClick}>
              <InvoiceTransactionContainer
                invoice={outstandingInvoice}
                actionLabel="Review payment"
                onAction={next}
              />
            </div>
          ) : null
        ) : activeTab === 'transactions' ? (
          <div className={styles.transactionsList}>
            {transactionRows.map((transaction) => (
              <TransactionPanel
                key={transaction.id}
                transaction={transaction}
              />
            ))}
          </div>
        ) : (
          <div className={styles.transactionsPlaceholder}>
            <h2 className={styles.transactionsTitle}>Messages</h2>
            <p className={styles.transactionsBody}>
              This is where you would see and send messages to your tenants.
            </p>
          </div>
        )}
      </div>
    </ManagerLayout>
  );
};

export default ManagerOutstandingScene;
